module.exports = __webpack_public_path__ + "img/GH-kyujin-top-010.7695734f.webp";